export default function OrderingMenuIcon({ fill = '#333' }) {
  return (
    <svg className="twenty" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_123_691)">
        <path d="M0.802246 20C0.359406 20 0 19.6288 0 19.1714V0.828638C0 0.37123 0.359406 0 0.802246 0C1.24509 0 1.60449 0.37123 1.60449 0.828638V19.1714C1.60449 19.6288 1.24509 20 0.802246 20Z" fill={fill} />
        <path d="M15.1978 5.84685H3.79944C3.3566 5.84685 2.99719 5.47562 2.99719 5.01821C2.99719 4.5608 3.3566 4.18958 3.79944 4.18958H15.1978C15.6406 4.18958 16 4.5608 16 5.01821C16 5.47562 15.6406 5.84685 15.1978 5.84685Z" fill={fill} />
        <path d="M15.1978 10.8254H3.79944C3.3566 10.8254 2.99719 10.4541 2.99719 9.99673C2.99719 9.53932 3.3566 9.16809 3.79944 9.16809H15.1978C15.6406 9.16809 16 9.53932 16 9.99673C16 10.4541 15.6406 10.8254 15.1978 10.8254Z" fill={fill} />
        <path d="M9.13277 15.8104H3.79944C3.3566 15.8104 2.99719 15.4391 2.99719 14.9817C2.99719 14.5243 3.3566 14.1531 3.79944 14.1531H9.12635C9.56919 14.1531 9.9286 14.5243 9.9286 14.9817C9.9286 15.4391 9.56919 15.8104 9.12635 15.8104H9.13277Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_123_691">
          <rect width="16" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
